import { render, staticRenderFns } from "./DayData.vue?vue&type=template&id=0a884a27&scoped=true&"
import script from "./DayData.vue?vue&type=script&lang=js&"
export * from "./DayData.vue?vue&type=script&lang=js&"
import style0 from "./DayData.vue?vue&type=style&index=0&id=0a884a27&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a884a27",
  null
  
)

export default component.exports